import { useMemo, useState } from "react";
import { featuredWorks } from "@/mocks/narutoData";
import SectionHeading from "./SectionHeading";

const filters = ["全部", "日常治愈", "深情羁绊", "热血成长", "历史长篇", "冷门佳作", "甜文HE"];

function heatLabel(v: number) {
  return v >= 10000 ? `${(v / 10000).toFixed(1)}万` : `${v}`;
}

export default function Featured() {
  const [active, setActive] = useState("全部");

  const list = useMemo(
    () => (active === "全部" ? featuredWorks : featuredWorks.filter((w) => w.category === active)),
    [active]
  );

  return (
    <section id="featured" className="scroll-mt-20 bg-background-50 py-16 md:py-24">
      <div className="mx-auto max-w-[1200px] px-4 md:px-6">
        <SectionHeading
          eyebrow="热门推荐"
          title="站内人气同人合集精选"
          desc="从经典长篇到冷门短篇，我们为你甄选出当前最受欢迎的优质同人作品，按主题与题材整理成册。"
        />

        <div className="mb-10 flex flex-wrap items-center justify-center gap-2 rounded-full border border-background-200 bg-background-100 px-1 py-1 mx-auto w-fit">
          {filters.map((f) => (
            <button
              key={f}
              onClick={() => setActive(f)}
              className={`whitespace-nowrap rounded-full px-4 py-2 text-sm transition-colors ${
                active === f
                  ? "bg-primary-500 text-background-50"
                  : "text-foreground-600 hover:text-primary-500"
              }`}
            >
              {f}
            </button>
          ))}
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {list.map((w) => (
            <article
              key={w.id}
              data-work
              className="group flex overflow-hidden rounded-lg border border-background-200 bg-background-100 transition-colors hover:border-primary-500/50"
            >
              <div className="relative h-auto w-32 md:w-36 shrink-0 overflow-hidden">
                <img
                  src={w.cover}
                  alt={`${w.title}火影忍者同人作品封面`}
                  className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                />
                <span className="absolute left-2 top-2 rounded-md bg-background-50/80 px-2 py-0.5 text-[11px] text-foreground-700 backdrop-blur-sm">
                  {w.category}
                </span>
              </div>
              <div className="flex flex-1 flex-col p-4">
                <h3 className="font-heading text-base md:text-lg font-bold text-foreground-950 leading-snug">
                  {w.title}
                </h3>
                <p className="mt-1.5 text-xs text-foreground-600">作者 · {w.author}</p>
                <p className="mt-2 line-clamp-2 text-xs md:text-[13px] leading-relaxed text-foreground-500">
                  {w.desc}
                </p>
                <div className="mt-3 flex flex-wrap gap-1.5">
                  {w.tags.map((t) => (
                    <span
                      key={t}
                      className="rounded-md bg-background-200/70 px-2 py-0.5 text-[11px] text-foreground-600"
                    >
                      {t}
                    </span>
                  ))}
                </div>
                <div className="mt-auto flex items-center justify-between pt-3 text-[11px] text-foreground-500">
                  <span className="flex items-center gap-1">
                    <i className="ri-file-list-3-line" /> {w.chapters}章
                  </span>
                  <span className="flex items-center gap-1">
                    <i className="ri-fire-fill text-primary-500" /> {heatLabel(w.heat)}
                  </span>
                  <span className="rounded-full border border-secondary-500/40 px-2 py-0.5 text-secondary-500">
                    {w.status}
                  </span>
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}